import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { PointsReason } from 'src/shared/schemas/points/points'

interface AddPointsData {
  user_id: number
  amount: number
  reason: PointsReason
  customMessage?: string
}

async function addPoints(data: AddPointsData): Promise<void> {
  const params = new URLSearchParams({
    user_id: data.user_id.toString(),
    amount: data.amount.toString(),
    reason: data.reason,
  })

  if (data.customMessage) {
    params.append('custom_message', data.customMessage)
  }

  await putRequest(`/users/add-points?${params.toString()}`)
}

export function useAddPoints() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addPoints,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.users.me.queryKey })
      queryClient.invalidateQueries({ queryKey: queries.notifications.list._def })
    },
  })
}
